import { OptimizelyDecision } from '@optimizely/react-sdk';

type PlanCode = 'fffvip' | 'fffvipa' | 'ffftrial' | 'fffsocial';

export interface Price {
  planCode: PlanCode;
  price: number | undefined;
  annualPrice: number | undefined;
  save: number;
}

export const getPriceByPlanCode = (prices: Price[], planCode: PlanCode) => {
  return prices.find((plan) => plan.planCode === planCode);
};

export const getSeasonalPriceWithFeatureFlag = (
  prices: Price[],
  flag: OptimizelyDecision | undefined,
  codePlan: PlanCode,
): Price | undefined => {
  const seasonalPlan = getPriceByPlanCode(prices, codePlan);

  if (flag?.enabled && seasonalPlan) {
    const basePlanPrice = seasonalPlan?.price || 0;
    const increasedAmount = flag.variables?.increasedPrice as number;
    const total = basePlanPrice + increasedAmount;
    const newPlan = {
      ...seasonalPlan,
      price: parseFloat(total.toFixed(2)),
    };

    return newPlan;
  }

  return seasonalPlan;
};
